import { gql } from '@apollo/client'

export default gql`
  query GET_MINI_MARKETPLACE_WIDGET_CARDS {
    miniMarketplaceWidgetCards {
      name
      slug
      image
      url
      issuerPublicName
      annualFeeFormatted
      ratesAndFeesUrl
      introBalanceTransferPeriodFormatted
      introPurchaseAprPeriodFormatted
      balanceTransferFeeFormatted
      rewardsUnit
      introBonusPoints
      introBonus
      miniMarketplaceFeaturedCategory {
        slug
      }
      rewardsRate
      worstCreditScoreCategory
      creditNeeded
      securityDepositMinimum
      aprRangeFormatted
    }
  }
`
